export default __webpack_public_path__ + "static/media/ISSO CLASS-5 EXAM PATTERN 2025.d5777246.pdf";